module.exports = __webpack_public_path__ + "static/media/figure4.de780b40.png";